var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-row"},_vm._l((_vm.tabs),function(tab,index){return _c('router-link',{key:index,attrs:{"to":tab.link}},[_c('div',{staticClass:"nav-item"},[_vm._v(_vm._s(tab.name))])])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }